import styled from 'styled-components';

export const EmojiWrapper = styled.div`
  transform: scale(1);
  filter: grayscale(100%);
  &:hover {
    filter: none;
  }
`;
